module.exports = __webpack_public_path__ + "static/guider-logo-cc5883fab8e3c8d463ddae76711960d6.png";